import React, { useEffect, useState } from "react";
import { FaArrowsRotate } from "react-icons/fa6";
import "./MerchantApiKeys.css";
import { getUserApiKeysData, rotateApiKey } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import RotateMsg from "./RotateMsg";
import ApiIntegrationModal from "./ApiIntegrationModal";

const ApiTable = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserDate] = useState([]);
  const [showRotateMsg, setShowRotateMsg] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newApiKey, setNewApiKey] = useState(null);
  const [showApiKeyModal, setShowApiKeyModal] = useState(false);

  const fetchMerchantApiData = async () => {
    setIsLoading(true);
    try {
      const response = await getUserApiKeysData(token);
      if (response?.data) {
        const adminsOnly = response.data.filter(
          (user) => user.user?.role === "admin"
        );
        setUserDate(adminsOnly);
        // console.log("Filtered Admins:", adminsOnly);
      }
    } catch (error) {
      console.log("errorerror::", error);
      toast.error("Failed to fetch merchant data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMerchantApiData();
  }, [token]);

  const handleRotateClick = (user) => {
    setSelectedUser(user);
    setShowRotateMsg(true);
  };

  const handleConfirmRotate = async (userName) => {
    try {
      const newKey = await rotateApiKey(token, selectedUser?.user?.id);
      setNewApiKey(newKey);
      setShowApiKeyModal(true);
      toast.success(`New API key genratre for ${userName}.`);
      setShowRotateMsg(false);
    } catch (error) {
      toast.error("Failed to rotate API key.");
    }
  };

  const handleCancelRotate = () => {
    setShowRotateMsg(false);
  };
  const handleCloseApiKeyModal = () => {
    setShowApiKeyModal(false);
  };

  return (
    <div className="webhooks-report-table-container">
      <h2 className="webhooks-report-table-title">Merchant API Keys</h2>
      <table className="webhooks-table">
        <thead>
          <tr>
            <th>Merchant Name</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="5">Loading...</td>
            </tr>
          ) : userData.length > 0 ? (
            userData.map((user) => (
              <tr key={user.id}>
                <td>{user?.user?.alias || user?.userId}</td>
                <td>
          {user.createdAt
            ? `${new Date(user.createdAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })} ${new Date(user.createdAt).toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              })}`
            : "N/A"}
        </td>
        <td>
          {user.updatedAt
            ? `${new Date(user.updatedAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })} ${new Date(user.updatedAt).toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              })}`
            : "N/A"}
        </td>
                <td>
                <FaArrowsRotate size={21} onClick={() => handleRotateClick(user)}/>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No admin merchants webhooks found.</td>
            </tr>
          )}
        </tbody>
      </table>
      {showRotateMsg && selectedUser && (
        <RotateMsg
          username={selectedUser?.user?.name}
          onConfirm={() => handleConfirmRotate(selectedUser?.user?.name)}
          onCancel={handleCancelRotate}
        />
      )}
      {showApiKeyModal && newApiKey && (
        <ApiIntegrationModal
          open={showApiKeyModal}
          handleClose={handleCloseApiKeyModal}
          apiKey={newApiKey}
        />
      )}
    </div>
  );
};

export default ApiTable;
